import ReportUtils from "../../../../../utils/report-utils.js";
import {translateStatus} from "../../utils/occurrence-dashboard-utils.js";

const VehiclesProfileContent = ({ data }) => {

    if (!data.vehiclesProfile?.length) {
        return (
            <div className="chart-report">
                <span className="chart-title">
                    Perfil mais presente por classificação
                </span>

                <div className="alert alert-info p-2 h6 text-center mt-3">
                    Nenhum registro encontrado no período informado.
                </div>
            </div>
        );
    }

    return (
        <div className="chart-report">
            <span className="chart-title">
                Perfil mais presente por classificação {data.vehiclesProfile?.length >= 5 ? " (TOP 5)" : ""}
            </span>

            <div className="mt-3 mb-3">
                <table id="average-profile-classification-data" className="table report-table">

                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            <th className="w-[7%]">Classificação</th>
                            <th className="w-[7%]">Quantidade</th>
                            <th className="w-[15%]">Tipo</th>
                            <th className="w-[15%]">Marca/Modelo</th>
                            <th className="w-[15%]">Cor</th>
                            <th className="w-[15%]">Ano de fabricação</th>
                            <th className="w-[15%]">Município da placa</th>
                        </tr>
                    </thead>

                    <tbody className="bg-white">
                        {data.vehiclesProfile.map((element, index) => (
                            <tr key={index}>
                                <td>{translateStatus(element.classif)}</td>
                                <td>{element.qty}</td>
                                <td>{ReportUtils.formatText(element.type)}</td>
                                <td>{element.brand_model}</td>
                                <td>{element.color}</td>
                                <td>{element.model_year}</td>
                                <td>{element.city_plate}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <span className="obs-warn">
                {data.vehiclesProfile?.length > 0 ? "* Informação baseada nas ocorrências do Sentry View" : ""}
            </span>
        </div>
    );
};

export default VehiclesProfileContent;